export default __webpack_public_path__ + "static/media/ShamaTirukkala_headshot.2ed8cdde.jpeg";